(function() { window.GUID_c292611a_a4b6_40ca_b27c_65a76a45ab2a = { getGuid: function() { return "c292611a-a4b6-40ca-b27c-65a76a45ab2a"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Views;
    (function (Views) {
        class PromotionalMaterial {
            constructor() {
                this.bindEvents();
            }
            bindEvents() {
                $(".promotional-material-item button").offon("click.promotionalmaterialitemButton", this.downloadPromotionalMaterial.bind(this));
                $(".promotional-material-item img").offon("click.promotionalmaterialitemImage", this.showFullScreenThumbnail.bind(this));
            }
            downloadPromotionalMaterial(e) {
                const $button = $(e.currentTarget);
                const fileURL = $button.attr("value");
                if (!fileURL) {
                    return;
                }
                const link = document.createElement("a");
                link.setAttribute("href", fileURL);
                link.setAttribute("download", "compusport-promotional-material");
                link.setAttribute("target", "_blank");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            showFullScreenThumbnail(e) {
                const $img = $(e.currentTarget);
                window.open($img.attr("src"), "_blank");
            }
        }
        Views.PromotionalMaterial = PromotionalMaterial;
        new PromotionalMaterial();
    })(Views = CompuSport.Views || (CompuSport.Views = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=PromotionalMaterial.js.map
